import { X, Loader2, Send } from "lucide-react"
import { Button } from "components/ui/button"
import type { ReviewFooterProps } from "../../types/components"

export const ReviewFooter = ({
  selectedCount,
  resendableCount,
  hasResendableItems,
  onBack,
  onReject,
  onResend,
  isLoading
}: ReviewFooterProps) => (
  <div className="flex items-center justify-between pt-3 border-t bg-white flex-shrink-0">
    <Button variant="outline" onClick={onBack} disabled={isLoading}>
      Cancelar
    </Button>

    <div className="flex gap-2">
      {onResend && hasResendableItems && (
        <Button
          variant="outline"
          onClick={onResend}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
          ) : (
            <Send className="w-4 h-4 mr-1" />
          )}
          Reenviar ({resendableCount})
        </Button>
      )}

      <Button
        variant="destructive"
        onClick={onReject}
        disabled={selectedCount === 0 || isLoading}
      >
        {isLoading ? (
          <Loader2 className="w-4 h-4 mr-1 animate-spin" />
        ) : (
          <X className="w-4 h-4 mr-1" />
        )}
        {isLoading ? "Processando..." : `Reprovar (${selectedCount})`}
      </Button>
    </div>
  </div>
)
